const FETCH_PACKAGE_LIST_SUCCESS = "FETCH_PACKAGE_LIST_SUCCESS";
const FETCH_PACKAGE_LIST_FAILURE = "FETCH_PACKAGE_LIST_FAILURE";

const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
const FETCH_NOTIFICATIONS_FAILURE = "FETCH_NOTIFICATIONS_FAILURE";

const FETCH_BULLETINS_SUCCESS = "FETCH_BULLETINS_SUCCESS";
const FETCH_BULLETINS_FAILURE = "FETCH_BULLETINS_FAILURE";

const FETCH_VIDEOS_LIST_SUCCESS = "FETCH_VIDEOS_LIST_SUCCESS";
const FETCH_VIDEOS_LIST_FAILURE = "FETCH_VIDEOS_LIST_FAILURE";

const FETCH_COUNSELING_TIMELINE_SUCCESS = "FETCH_COUNSELING_TIMELINE_SUCCESS";
const FETCH_COUNSELING_TIMELINE_FAILURE = "FETCH_COUNSELING_TIMELINE_FAILURE";

const FETCH_COUNSELLINGS_SUCCESS = "FETCH_COUNSELLINGS_SUCCESS";
const FETCH_COUNSELLINGS_FAILURE = "FETCH_COUNSELLINGS_FAILURE";

const FETCH_DASHBOARD_INFO_SUCCESS = "FETCH_DASHBOARD_INFO_SUCCESS";
const FETCH_DASHBOARD_INFO_FAILURE = "FETCH_DASHBOARD_INFO_FAILURE";

const FETCH_SOCIAL_MEDIA_UPDATES_SUCCESS = "FETCH_SOCIAL_MEDIA_UPDATES_SUCCESS";
const FETCH_SOCIAL_MEDIA_UPDATES_FAILURE = "FETCH_SOCIAL_MEDIA_UPDATES_FAILURE";

const FETCH_BULLETIN_SUCCESS = "FETCH_BULLETIN_SUCCESS";
const FETCH_BULLETIN_FAILURE = "FETCH_BULLETIN_FAILURE";

const FETCH_ANNOUNCEMENT_FILTERS_SUCCESS = "FETCH_ANNOUNCEMENT_FILTERS_SUCCESS";
const FETCH_ANNOUNCEMENT_FILTERS_FAILURE = "FETCH_ANNOUNEMENT_FILTERS_FAILURE";

const FETCH_ANNOUNCEMENTS_SUCCESS = "FETCH_ANNOUNCEMENTS_SUCCESS";
const FETCH_ANNOUNCEMENTS_FAILURE = "FETCH_ANNOUNCEMENTS_FAILURE";

const FETCH_EVENT_FILTERS_SUCCESS = "FETCH_EVENT_FILTERS_SUCCESS";
const FETCH_EVENT_FILTERS_FAILURE = "FETCH_EVENT_FILTERS_FAILURE";

const FETCH_EVENTS_SUCCESS = "FETCH_EVENTS_SUCCESS";
const FETCH_EVENTS_FAILURE = "FETCH_EVENTS_FAILURE";

const UPDATE_META_EMAIL_VERIFIED = "UPDATE_META_EMAIL_VERIFIED";

export {
  FETCH_PACKAGE_LIST_SUCCESS,
  FETCH_PACKAGE_LIST_FAILURE,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILURE,
  FETCH_BULLETINS_SUCCESS,
  FETCH_BULLETINS_FAILURE,
  FETCH_VIDEOS_LIST_SUCCESS,
  FETCH_VIDEOS_LIST_FAILURE,
  FETCH_COUNSELING_TIMELINE_SUCCESS,
  FETCH_COUNSELING_TIMELINE_FAILURE,
  FETCH_COUNSELLINGS_SUCCESS,
  FETCH_COUNSELLINGS_FAILURE,
  FETCH_DASHBOARD_INFO_SUCCESS,
  FETCH_DASHBOARD_INFO_FAILURE,
  FETCH_SOCIAL_MEDIA_UPDATES_SUCCESS,
  FETCH_SOCIAL_MEDIA_UPDATES_FAILURE,
  FETCH_BULLETIN_SUCCESS,
  FETCH_BULLETIN_FAILURE,
  FETCH_ANNOUNCEMENT_FILTERS_SUCCESS,
  FETCH_ANNOUNCEMENT_FILTERS_FAILURE,
  FETCH_EVENT_FILTERS_SUCCESS,
  FETCH_EVENT_FILTERS_FAILURE,
  FETCH_EVENTS_SUCCESS,
  FETCH_EVENTS_FAILURE,
  FETCH_ANNOUNCEMENTS_SUCCESS,
  FETCH_ANNOUNCEMENTS_FAILURE,
  UPDATE_META_EMAIL_VERIFIED,
};
